import React from "react";
import ShipMaintenanceTable from "./components/ShipMaintenanceTable";

function App() {
  return (
    <div>
      <ShipMaintenanceTable />
    </div>
  );
}

export default App;
